var _g, _rect, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComplete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "complete",
    xmlns: "http://www.w3.org/2000/svg",
    width: 224.5,
    height: 181.694,
    viewBox: "0 0 224.5 181.694",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1148",
    "data-name": "Grupo 1148",
    transform: "translate(35.673 34.45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_6",
    "data-name": "L\\xEDnea 6",
    y2: 32.896,
    transform: "translate(5.115 0)",
    fill: "none",
    stroke: "#58595b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_7",
    "data-name": "L\\xEDnea 7",
    x2: 10.231,
    transform: "translate(0 32.896)",
    fill: "none",
    stroke: "#58595b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_8",
    "data-name": "L\\xEDnea 8",
    x2: 10.231,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#58595b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1056",
    "data-name": "Rect\\xE1ngulo 1056",
    width: 224.5,
    height: 181.694,
    rx: 11.027,
    fill: "#9d00ff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1173",
    "data-name": "Grupo 1173",
    transform: "translate(23.041 16.475)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1057",
    "data-name": "Rect\\xE1ngulo 1057",
    width: 179.146,
    height: 41.256,
    rx: 7.115,
    transform: "translate(0 0)",
    fill: "#6d00b3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1172",
    "data-name": "Grupo 1172",
    transform: "translate(140.442 10.232)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_139",
    "data-name": "Elipse 139",
    cx: 10.396,
    cy: 10.396,
    rx: 10.396,
    ry: 10.396,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2956",
    "data-name": "Trazado 2956",
    d: "M233.913,2076.465l3.513,3.179,7.591-9.373",
    transform: "translate(-228.929 -2064.425)",
    fill: "none",
    stroke: "#9d00ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1058",
    "data-name": "Rect\\xE1ngulo 1058",
    width: 56.273,
    height: 13.84,
    transform: "translate(12.25 14.767)",
    fill: "#fff",
    opacity: 0.15
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1175",
    "data-name": "Grupo 1175",
    transform: "translate(21.776 70.219)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1059",
    "data-name": "Rect\\xE1ngulo 1059",
    width: 179.146,
    height: 41.256,
    rx: 7.115,
    transform: "translate(0 0)",
    fill: "#6d00b3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1174",
    "data-name": "Grupo 1174",
    transform: "translate(140.442 10.232)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_140",
    "data-name": "Elipse 140",
    cx: 10.396,
    cy: 10.396,
    rx: 10.396,
    ry: 10.396,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2957",
    "data-name": "Trazado 2957",
    d: "M233.913,2095.984l3.513,3.179,7.591-9.372",
    transform: "translate(-228.929 -2083.945)",
    fill: "none",
    stroke: "#9d00ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1060",
    "data-name": "Rect\\xE1ngulo 1060",
    width: 120.679,
    height: 13.84,
    transform: "translate(12.25 14.767)",
    fill: "#fff",
    opacity: 0.15
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1569",
    "data-name": "Grupo 1569",
    transform: "translate(21.776 125.474)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1057-2",
    "data-name": "Rect\\xE1ngulo 1057",
    width: 179.146,
    height: 41.256,
    rx: 7.115,
    transform: "translate(0 0)",
    fill: "#6d00b3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1172-2",
    "data-name": "Grupo 1172",
    transform: "translate(140.442 10.232)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_139-2",
    "data-name": "Elipse 139",
    cx: 10.396,
    cy: 10.396,
    rx: 10.396,
    ry: 10.396,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2956-2",
    "data-name": "Trazado 2956",
    d: "M233.913,2076.465l3.513,3.179,7.591-9.373",
    transform: "translate(-228.929 -2064.425)",
    fill: "none",
    stroke: "#9d00ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1058-2",
    "data-name": "Rect\\xE1ngulo 1058",
    width: 56.273,
    height: 13.84,
    transform: "translate(12.25 14.767)",
    fill: "#fff",
    opacity: 0.15
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.407644b8.svg";
export { ForwardRef as ReactComponent };